module.exports = __webpack_public_path__ + "media/images/icon-link@3x-62ed098cb7efd01c3b43cbe7608d948e.png";